const columns = [
    {
        title: 'Transfer Method',
        dataIndex: 'name',
    },
    {
        title: 'Currency',
        dataIndex: 'currency',
    },
    {
        title: 'Fees / Commission(%)',
        dataIndex: 'fees',
    },
    {
        title: 'Processing Time',
        dataIndex: 'processingTime',
    },
    {
        title: '',
        dataIndex: 'status',
    }
];

export default columns;